import styled from 'styled-components';
import { Image as ChackraImage, Link } from '@chakra-ui/react';

export const Label = styled.span`
  font-weight: 700;
  margin-bottom: 12px;
  font-size: 18px;
`;

export const Logo = styled(ChackraImage)`
  width: 200px;
  height: 150px;
  object-fit: contain;
  margin-top: -20px;
`;

export const Text = styled.span`
  margin: 20px auto;
  font-size: 14px;
`;

export const Anchor = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700;
  cursor: pointer;
`;
